import React from "react";
import { useI18n } from "../../i18n";

const STEP_IMAGE =
  "https://images.unsplash.com/photo-1544031064-9de80864ade5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwY2FmZSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTAwNDg0MXww&ixlib=rb-4.1.0&q=85";

export default function HowItWorks() {
  const { t } = useI18n();
  const steps = [
    { t: t("how.s1_t"), d: t("how.s1_d") },
    { t: t("how.s2_t"), d: t("how.s2_d") },
    { t: t("how.s3_t"), d: t("how.s3_d") },
    { t: t("how.s4_t"), d: t("how.s4_d") },
  ];

  return (
    <section id="how" className="section-y bg-brand-sand" data-testid="how-section">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="eyebrow reveal">{t("how.eyebrow")}</p>
          <h2 className="display-h2 mt-4 text-brand-ink reveal" data-delay="1" data-testid="how-title">
            {t("how.title")}
          </h2>
          <div className="mt-10 relative rounded-[24px] overflow-hidden border border-brand-line reveal" data-delay="2">
            <img
              src={STEP_IMAGE}
              alt="Bright minimal dining room"
              className="w-full h-[360px] md:h-[460px] object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <ol className="lg:col-span-7 relative">
          <span aria-hidden className="absolute left-[18px] top-2 bottom-2 w-px bg-brand-line hidden md:block" />
          {steps.map((s, i) => (
            <li
              key={i}
              className="reveal flex gap-6 md:gap-8 pb-10 md:pb-14 last:pb-0"
              data-delay={i + 1}
              data-testid={`how-step-${i + 1}`}
            >
              <div className="relative shrink-0">
                <div className="h-9 w-9 md:h-10 md:w-10 rounded-full bg-brand-forest text-brand-ivory font-serif text-lg md:text-xl flex items-center justify-center">
                  {i + 1}
                </div>
              </div>
              <div className="pt-1">
                <h3 className="display-h3 text-brand-ink">{s.t}</h3>
                <p className="body-lg mt-3 max-w-lg">{s.d}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
